export class LocElementsStorage {
    public static elements: any = [];
}